export default __webpack_public_path__ + "static/media/home-decor-img-16.0bce24de.png";